import React, { Component } from 'react';
import { Carousel, Tabs, Tab } from 'react-bootstrap';
import numeral from 'numeral';
import { Header } from '../App';
import LeafletMap from '../map/LeafletMap';
import 'bootstrap/dist/css/bootstrap.css';
import './Site.css';
import data from '../assets/data/sites.json';


class Site extends Component {
    constructor(props) {
        super(props);
        this.site = null;
        for (let i = data.features.length - 1; i >= 0; i--) {
            if (data.features[i].properties.id === props.match.params.id) {
                this.site = data.features[i];
            }
        }


        if (this.site === null) {
            throw Error("Unable to find site: " + props.match.params.id);
        }

        if (this.site.geometry.coordinates.length === 2) {
            this.site.properties.life_zone = "N/A";
        }
        else {
            let elevation = this.site.geometry.coordinates[2];
            
            if (elevation > 11000) {
                this.site.properties.life_zone = "Alpine";
            }
            else if (elevation >= 9000) {
                this.site.properties.life_zone = "Sub-Alpine";
            }
            else if (elevation >= 7000) {
                this.site.properties.life_zone = "Montane";
            }
            else if (elevation >= 5600) {
                this.site.properties.life_zone = "Foothills";
            }
            else if (elevation >= 0) {
                this.site.properties.life_zone = "Plains";
            }
        }

        let displayCategories = this.site.properties.measurement_categories.slice(0);
        for (let i = 0; i < displayCategories.length; i++) {
            displayCategories[i] = displayCategories[i][0].toUpperCase() + displayCategories[i].substr(1);
        }
        this.site.properties.display_categories = displayCategories;

        this.carouselImages = [];
        this.carouselItems = [];

        if (this.site.properties.links && this.site.properties.links.images) {
            this.carouselImages = this.site.properties.links.images;
        }

        for (let i = 0, imageInclude = null; i < this.carouselImages.length; i++) {
            try {
                imageInclude = require("../assets/photos/" + this.carouselImages[i]);
                this.carouselItems.push(
                    <Carousel.Item key={this.site.id + i}>
                        <img className='img-responsive' alt={this.carouselImages[i]}
                             src={imageInclude}
                             style={{height: 750, maxHeight: 750, width: 'auto'}}/>
                    </Carousel.Item>
                );
            }
            catch (e) {
                console.log("Unable to find photo: " + this.carouselImages[i]);
            }
        }        
    }
    
    componentDidMount() {
        document.documentElement.className = 'site';
        document.body.className = 'site';
    }
    
    render() {        
        let carousel = (
            <Carousel controls={true}
                      indicators={true}
                      defaultActiveIndex={0}>
                {this.carouselItems}
            </Carousel>
        );
        
        if (this.carouselItems.length === 0) {
            carousel = (<div className="text-danger" style={{textAlign: 'center'}}><h1>No photos available for this site</h1></div>);
        }
        
        return(
        <div id='site-content' style={{overflow: 'scroll !important'}}>
                <div className='container-fluid'>
                    <div id='navbar'>
                        <Header/>
                    </div>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <h3 style={{marginTop: 0}}>{this.site.id + ': ' + this.site.properties.name}</h3>
                            <h4 className="text-danger"><b>{this.site.properties.research_theme}</b></h4>
                        </div>
                        <div className='col-sm-4'>
                            <b>Location</b>
                            <div style={{position: 'relative', left: 2.3 + 'vh'}}>
                                <div>Lat, Lon: {this.site.geometry.coordinates[1].toFixed(4)}, {this.site.geometry.coordinates[0].toFixed(4)}</div>
                                <div>Elevation: {this.site.geometry.coordinates.length === 3 ? numeral(this.site.geometry.coordinates[2]).format('0,0') + ' m' : "N/A"}</div>
                                <div>Estimated Life Zone: {this.site.properties.life_zone}</div>
                            </div>
                            <br/>
                            <b>Site Category</b>
                            <div style={{position: 'relative', left: 2.3 + 'vh'}}>
                                <div>{this.site.properties.category}</div>
                            </div>
                            <br/>
                            <b>Site Contact</b>
                            <div style={{position: 'relative', left: 2.3 + 'vh'}}>
                                <a href={"mailto:" + this.site.properties.contact.email} target="_top">{this.site.properties.contact.name}</a>
                            </div>
                            <br/>
                            <b>Measurement Types</b>
                            <div style={{position: 'relative', left: 2.3 + 'vh'}}>
                                <div>
                                    {this.site.properties.display_categories.join()}
                                    {/*<img width={20} height={20} src={bgcIcon}/>*/}
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-8'>
                            <b>Description</b>
                            <div style={{position: 'relative', left: 2.3 + 'vh', marginRight: 15 + 'px'}}>
                                <div>{this.site.properties.description}</div>
                            </div>
                            <br/>
                            <b>Instrumentation</b>
                            <div style={{position: 'relative', left: 2.3 + 'vh', marginRight: 15 + 'px'}}>
                                <div dangerouslySetInnerHTML={{__html: this.site.properties.instrumentation}}/>
                            </div>
                            <br/>
                            <b>Variables Measured</b>
                            <div style={{position: 'relative', left: 2.3 + 'vh', marginRight: 15 + 'px'}}>
                                <p>{this.site.properties.variables_measured}</p>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div className='row'>
                        <div className='col-sm-12' style={{height: 750, maxHeight: 750, width: 100 + '%'}}>
                            <Tabs defaultActiveKey={2} bsStyle='pills' id="interactive" style={{height: 750, maxHeight: 750, width: 100 + '%'}}>
                                <Tab eventKey={1} title="Map" className='map-container' style={{height: 750, maxHeight: 750, width: 100 + '%'}}>
                                    <LeafletMap sites={data} activeSite={this.site} focusOnSite={true} style={{height: 750, maxHeight: 750, width: 100 + '%'}}/>
                                </Tab>
                                <Tab eventKey={2} title="Photos" style={{height: 750, maxHeight: 750, width: 'auto'}}>
                                    {carousel}
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Site;


// WEBPACK FOOTER //
// ./src/siteview/Site.js